const calculateGridRows = (containerElement) => {
  const rows = [];
  let currentRow = [];
  let currentRowOffsetTop = 0;

  [...containerElement.children].forEach(child => {
    child.classList.remove('mn_hidden');

    if (child.offsetTop !== currentRowOffsetTop) {
      currentRowOffsetTop = child.offsetTop;
      currentRow = [];
      rows.push(currentRow);
    }
    currentRow.push(child);
  });

  return rows;
};

export const hideIncompleteRow = (containerElement, showOnlyOneRow) => {
  if (!containerElement) {
    return;
  }

  const rows = calculateGridRows(containerElement);
  const firstRow = rows[0];
  const lastRow = rows[rows.length - 1];

  const hideElements = (row) => {
    row.forEach(elem => {
      elem.classList.add('mn_hidden');
    });
  };

  if (showOnlyOneRow) {
    rows.forEach((row, index) => {
      if (index !== 0) {
        hideElements(row);
      }
    });

    return;
  }

  if (lastRow && firstRow && lastRow.length < firstRow.length) {
    hideElements(lastRow);
  }
};
